// src/data/matiere-to-agent.js
// Mapping entre la matière d'un dossier (client_dossiers.matiere) et l'agent
// à privilégier par défaut pour une tâche liée (audience, RDV, rédaction…).
//
// Utilisé par AgendaPage → "Confier une tâche à un agent" : quand un event
// est rattaché à un dossier dont la matière est connue, on présélectionne
// l'agent correspondant. L'avocat peut toujours choisir un autre agent.

import { AGENTS } from './agents';

// id = id d'un agent dans AGENTS (src/data/agents.js)
export const MATIERE_TO_AGENT_ID = {
  penal: 'francoise',
  civil: 'claire',
  famille: 'margaux',
  corporel: 'louise',
  successions: 'pierre',
  travail: 'antoine',
  affaires: 'thomas',
  commercial: 'thomas',
  societes: 'thomas',
  pi: 'camille',
  consommation: 'camille',
  immobilier: 'nadia',
  administratif: 'helene',
  environnement: 'sarah',
  'procedures-collectives': 'mathilde',
  fiscal: 'alexandre',
  rgpd: 'lea',
};

// Helper : renvoie l'agent full object pour une matière, ou null.
export function agentForMatiere(matiere) {
  if (!matiere) return null;
  const m = String(matiere).toLowerCase().trim();
  const id = MATIERE_TO_AGENT_ID[m];
  if (!id) return null;
  return AGENTS.find(a => a.id === id) || null;
}

// Détection secondaire : à partir des abréviations juridiques dans le titre
// de l'event, tenter de déduire une matière quand le dossier n'est pas
// rattaché. Conservatrice : ne répond que si le pattern est certain.
const TITLE_HINTS = [
  { re: /\bJLD\b|\bCRPC\b|\bCP\b|\bGAV\b|\bMP\b|\bPP\b|comparution|audience\s+corr/i, matiere: 'penal' },
  { re: /\bJAF\b|divorce|\bpension\b|enfant|résidence|autorité parentale/i, matiere: 'famille' },
  { re: /\bTC\b|tribunal\s+commerce|liquidation|redressement/i, matiere: 'procedures-collectives' },
  { re: /\bCPH\b|prud'hommes|conseil\s+des\s+prud/i, matiere: 'travail' },
  { re: /\bTA\b|tribunal\s+administratif|\bCRA\b|\bCNDA\b|OQTF/i, matiere: 'administratif' },
  { re: /\bJEX\b|saisie|expulsion/i, matiere: 'immobilier' },
  { re: /\bCIVI\b|\bSARVI\b|corporel|indemnisation/i, matiere: 'corporel' },
  { re: /\bJI\b|instruction/i, matiere: 'penal' },
];

export function matiereFromTitle(title) {
  if (!title) return null;
  for (const h of TITLE_HINTS) {
    if (h.re.test(title)) return h.matiere;
  }
  return null;
}
